import { isPlainObject } from './utils';

const EMPTY_VALUE = '';

/**
 * @param {Function | Number | RegExp} mapper
 * @param {*} value
 */
function mapValue(mapper, value) {
  if (!mapper) {
    return value;
  }

  if (mapper === Number) {
    return parseInt(value, 10);
  }

  if (mapper === RegExp) {
    return new RegExp(value);
  }

  return mapper(value);
}

/**
 * Normalizes data object from back-end. Converts specified properties via map functions
 * @param {Object} object Data object
 * @param {Object} [context={}]
 * @param {Object} [context.defaults={}] Default values object
 * @param {Object} [context.mappers={}] Object like { prop1: (value) => value + 1, prop2: { prop3: value => value.toString() } }
 * @returns {Object} Normalized object
 */
export function normalizeDataObject(object, context = {}) {
  const { defaults = {}, mappers = {} } = context;

  // Get all unique keys
  const allKeys = Object.keys(defaults).concat(Object.keys(object))
    .filter((key, index, keys) => index === keys.indexOf(key));

  return allKeys.reduce((result, key) => {
    let value = object[key] === EMPTY_VALUE ? undefined : object[key];
    const defaultValue = defaults[key];
    /** @type {Function | Object} */
    const mapper = mappers[key];

    if (isPlainObject(value)) {
      result[key] = normalizeDataObject(value, { defaults: defaultValue, mappers: mapper });
    } else {
      if (value === undefined) {
        value = defaultValue;
      } else {
        value = mapValue(mapper, value);
      }

      if (value !== undefined) {
        result[key] = value;
      }
    }

    return result;
  }, {});
}
